import React, { useState } from 'react'
import FreezeIcons from './FreezeIcons'
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { ExpandIcon } from 'common/components/icons';
import { Accordion, Grid,Typography, AccordionSummary, AccordionDetails, TableHead } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {
    root: {
        width: '100%',
    },
    typography: {
        display: "inline-block",
    },
    lbCountLabel: {
        extend: 'typography',
        paddingTop: '1.5px'
    },
    RLCdetails:{
      paddingTop: "0px",  
    },
    subGrid:{
        width: "98%",
        margin: "auto",
    },
    innerGrid: {
        marginTop: "5px",
        marginBottom: "5px",
    },
    innerGridItem:{
        padding: "5px",
    },
    currentFreezeIcon:{
        color: "#1976d2",
        marginBottom: "-5px",
    },
    pastFreezeIcon:{
        color: "rgba(0, 0, 0, 0.54)",
        marginBottom: "-5px",
    },
    controllersPaper:{
        backgroundColor: "#f7f7f7",
        width: "100%",
        padding: "10px",
        marginBottom: "10px",
    },
    podsPaper:{
        width: "100%",
        padding: "5px",
        marginBottom: "10px",
    },
    warning:{
        backgroundColor: "rgb(255, 244, 229)",
    },
    warningPodsPaper:{
        extend: 'podsPaper',
        backgroundColor: "rgb(255, 244, 229)",
    },
    tableRow: {
        backgroundColor: 'white',
    },
    smallTableCol: {
        width: '30px',
        padding: '0 5px',
        borderLeft: '1px solid rgba(224, 224, 224, 1)',
        borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    smallTableRow: {
        height: '25px',
    },
    midTableRow: {
        height: '35px',
    },
};

const RLCPanel = ({ classes, RLCId, RLCData, devices_info }) => {
    const [expanded, setExpanded] = useState(false)

    const reducer = (acc, curr) => acc + curr[1] + " (id:" + curr[0] + "), "
    let appListString = RLCData['app_list'].reduce(reducer, "").slice(0, -2)

    const containerHasWarningPods = (container) => {
        for (const [, c] of Object.entries(container['controllers'])) {
            for (const [, p] of Object.entries(c['pods'])) {
                if (podHasHighRestarts(p))
                    return true;
            };
        };
        return false;
    }

    const podHasHighRestarts = (pod) => {
        if (parseInt(pod['container_restart_count']) > 5 || parseInt(pod['pod_restart_count']) > 5)
            return true;
        return false;
    }

    return <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
                expandIcon={<ExpandIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className={containerHasWarningPods(RLCData) ? classes.warning : null}
            >
            <Grid container className={classes.container} spacing={1} alignItems="center">
                <Grid item>
                    <Typography className={classes.typography} variant='subtitle2'>{RLCId}</Typography>
                </Grid> 
                <Grid item>
                    <FreezeIcons current_fe_dict={RLCData['current_freeze_event']} past_fe_dict={RLCData['past_freeze_event']}/>
                </Grid>
                <Grid container item xs spacing={1} justifyContent="flex-end" alignItems="flex-end">
                    <Grid item>
                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">
                            {RLCData['pod_count']} Pods
                        </Typography>
                    </Grid>                
                </Grid>
            </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.RLCdetails}>
            <Grid container direction="column" spacing={1} className={classes.subGrid}>
                <Grid item container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid container direction="column" spacing={1} item style={{'width': '85%'}}>
                        <Grid item>
                            <Typography variant='caption' color="textSecondary">Account</Typography><br/>
                            {RLCData['account_name']} (id: {RLCData['account_id']})
                        </Grid>
                        <Grid item>
                            <Typography variant='caption' color="textSecondary">Applications</Typography><br/>
                            {appListString}
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Table>
                            <TableHead>
                                <TableRow className={classes.smallTableRow} style={{'borderTop': '1px solid rgba(224, 224, 224, 1)'}}>
                                    <TableCell  className={classes.smallTableCol} colSpan={3} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP</Typography>
                                    </TableCell>
                                    <TableCell  className={classes.smallTableCol} colSpan={3} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow className={classes.smallTableRow}>
                                    <TableCell  className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">CPS</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                    <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">RPS</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">Conns</Typography>
                                    </TableCell>
                                    <TableCell  className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">CPS</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                    <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">RPS</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">Conns</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            <TableRow className={classes.smallTableRow}>
                                    <TableCell  className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{RLCData['connections']['http_delta_connections']}</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                    <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{RLCData['connections']['http_delta_requests']}</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{RLCData['connections']['current_http_metric']}</Typography>
                                    </TableCell>
                                    <TableCell  className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{RLCData['connections']['https_delta_connections']}</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                    <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{RLCData['connections']['https_delta_requests']}</Typography>
                                    </TableCell>
                                    <TableCell className={classes.smallTableCol} align="center">
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">{RLCData['connections']['current_https_metric']}</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
                <Grid item>
                    {RLCData['controllers'].map((c) =>
                    <Paper key={c['id']} className={classes.controllersPaper}>
                        <Grid container spacing={1}>
                            <Grid item container xs={12} spacing={1}>
                                <Grid item>
                                    <Typography variant='caption' color="textSecondary">Controller</Typography>
                                </Grid>
                                <Grid item>
                                    {c['id']}
                                    {(devices_info && Object.keys(devices_info).length !== 0 && c in devices_info) &&
                                    <b> (STM v{devices_info[c]['version']})</b>}
                                </Grid>
                                <Grid item>
                                    <FreezeIcons current_fe_dict={c['current_freeze_event']} past_fe_dict={c['past_freeze_event']}/>
                                </Grid>
                                <Grid container item xs spacing={1} justifyContent="flex-end" alignItems="flex-end">
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP CPS: {c['connections']['http_delta_connections']},</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS CPS: {c['connections']['https_delta_connections']},</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP RPS: {c['connections']['http_delta_requests']},</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS RPS: {c['connections']['https_delta_requests']},</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTP Conns: {c['connections']['current_http_metric']},</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">HTTPS Conns: {c['connections']['current_https_metric']},</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography className={classes.lbCountLabel} variant='caption' color="textSecondary">
                                            {c['pod_count']} Pods
                                        </Typography>
                                    </Grid>                
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Table>
                                    <TableHead>
                                        <TableRow className={classes.midTableRow}>
                                            <TableCell style={{'width': '290px'}} colSpan={3} align="center">
                                                Name
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} colSpan={2} align="center">
                                                Status
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} colSpan={2} align="center">
                                                Restart Count
                                            </TableCell>
                                            <TableCell  className={classes.smallTableCol} colSpan={3} align="center">
                                                HTTP
                                            </TableCell>
                                            <TableCell  className={classes.smallTableCol} colSpan={3} align="center">
                                                HTTPS
                                            </TableCell>
                                        </TableRow>
                                        <TableRow className={classes.midTableRow}>
                                            <TableCell style={{'width': '300px'}}>
                                                Pod
                                            </TableCell>
                                            <TableCell style={{'width': '400px'}}>
                                                Container
                                            </TableCell>
                                            <TableCell style={{'width': '280px'}}>
                                                Node 
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center"> 
                                                Pod
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center"> 
                                                Container
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center"> 
                                                Pod
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center"> 
                                                Container
                                            </TableCell>
                                            <TableCell  className={classes.smallTableCol} align="center">
                                                CPS
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center">
                                                RPS
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center">
                                                Conns
                                            </TableCell>
                                            <TableCell  className={classes.smallTableCol} align="center">
                                                CPS
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center">
                                                RPS
                                            </TableCell>
                                            <TableCell className={classes.smallTableCol} align="center">
                                                Conns
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className={classes.tableRow}>
                                        {Object.keys(c['pods']).map((p) => {
                                            if (devices_info && Object.keys(devices_info).length !== 0 && c['pods'][p]['container_id'] in devices_info)
                                                devices_info[c] = devices_info[c['pods'][p]['container_id']]
                                            return <TableRow key={p} className={podHasHighRestarts(c['pods'][p]) ? classes.warningPodsPaper : classes.podsPaper}>
                                                <TableCell style={{'width': '300px'}}>
                                                    {p}
                                                </TableCell>
                                                <TableCell style={{'width': '400px'}}>
                                                    {c['pods'][p]['container_name']}
                                                </TableCell>
                                                <TableCell style={{'width': '280px'}} >
                                                    {c['pods'][p]['node']}
                                                    <FreezeIcons current_fe_dict={c['pods'][p]['current_freeze_event']} past_fe_dict={c['pods'][p]['past_freeze_event']}/>
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['pod_status']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['container_status']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center"> 
                                                    {c['pods'][p]['pod_restart_count']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center"> 
                                                    {c['pods'][p]['container_restart_count']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['connections']['http_delta_connections']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['connections']['https_delta_connections']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['connections']['http_delta_requests']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['connections']['https_delta_requests']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['connections']['current_http_metric']}
                                                </TableCell>
                                                <TableCell className={classes.smallTableCol} align="center">
                                                    {c['pods'][p]['connections']['current_https_metric']}
                                                </TableCell>
                                            </TableRow>
                                        })}
                                    </TableBody>
                                </Table>
                            </Grid>
                        </Grid>
                    </Paper>)}
                </Grid>
            </Grid>
        </AccordionDetails>
    </Accordion>
};

export default withStyles(styles)(RLCPanel);